export async function* fromSingle(value) {
    yield value;
}
export async function first(generator) {
    const { done, value } = await generator.next();
    if (done)
        throw Error("The generator should yield at least one value.");
    return value;
}
